import { useMemo } from 'react';
import { Flex, Grid, theme } from 'antd';
import { LocationPlaysResponse, SelectedPlatform } from '@/types/api/location';
import { MapDataByPlatformEcho } from './MapDataByPlatformEcho';
import { mixpanelTrack, RevenueDashboardWidget } from '@/utils';
import { MIXPANEL_EVENT } from '@/utils/mixpanelUtils/events';
import LocationMapEcho from './LocationMapEcho';

type Geography = {
  id: string;
  properties: {
    name: string;
  };
  rsmKey: string;
};

const MapChartEcho = ({
  data,
  selectedPlatform,
  handlePlatformChange,
}: {
  data: LocationPlaysResponse;
  selectedPlatform: SelectedPlatform<typeof data>;
  handlePlatformChange: (platform: SelectedPlatform<typeof data>) => void;
}) => {
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();
  const isExtraLargeScreen = Boolean(screens.xl);

  const platformData = useMemo(
    () => data.plays.find((play) => play.platform === selectedPlatform)?.country_distribution ?? [],
    [data.plays, selectedPlatform]
  );

  const handleCountryHover = (geography: Geography, plays: number) => {
    mixpanelTrack(MIXPANEL_EVENT.audience.demographics.chartTooltipHover, {
      widget: RevenueDashboardWidget.LocationDemographics,
      page: 'audience',
      platform: selectedPlatform,
      demographics: 'location',
      segment: geography?.properties.name || '',
      plays: plays ? `${plays}` : '0',
    });
  };

  return (
    <Flex vertical={!isExtraLargeScreen} align="center">
      <Flex
        justify="center"
        style={{
          width: isExtraLargeScreen ? '40%' : '100%',
          paddingInlineEnd: isExtraLargeScreen ? token.padding : token.paddingXL,
        }}
      >
        <LocationMapEcho platformData={platformData} onCountryHover={handleCountryHover} />
      </Flex>
      <Flex
        align="center"
        justify="center"
        style={{
          width: isExtraLargeScreen ? '60%' : '100%',
          marginBottom: token.marginLG,
        }}
      >
        <MapDataByPlatformEcho
          data={data}
          selectedPlatform={selectedPlatform}
          handlePlatformChange={handlePlatformChange}
        />
      </Flex>
    </Flex>
  );
};

export default MapChartEcho;
